import React from "react";
import YearlyPackageInfo from "pages/Front/Booking/components/YearlyPackage/components/YearlyPackageInfo";
import {useTranslation} from "react-i18next";

interface Yearly12MonthsDescriptionProps {
}

const Yearly12MonthsDescription = (props: Yearly12MonthsDescriptionProps) => {
    const {t} = useTranslation();
    return (
        <YearlyPackageInfo
            headerLine={t("12 months of continuous fun")}
            articleName={t("Annual - ABO")}
            descriptionTitle={t("For all fans that have never enough")}
            points={[
                t("Valid 12 months"),
                t("4 Hours Entry 'Yellow'"),
                t("1 Entry per day"),
                t("Valid every day on official opening hours (Midweek and Weekend)"),
                t("Karting not included. Available separately for discounted price CHF 9.95"),
            ]}
        />
    );
};

export default Yearly12MonthsDescription;